import { useState } from "react";

import { defaultFiltersParams } from "#app/routes/pages/Search.page";
import { FilterQuery } from "shared";

export const useFilters = () => {
  const [filtersParams, setFiltersParams] = useState<FilterQuery>(defaultFiltersParams);

  return {
    filtersParams,
    setFiltersParams,
  };
};
